module.exports = __webpack_public_path__ + "img/pic3.d6f09bb5.png";